var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _circle2, _circle3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgComputerChips = function SvgComputerChips(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "computer_chips",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.63,
    y: 138.41,
    width: 493.59,
    height: 357.35,
    transform: "translate(-79.09 101.19) rotate(-16.88)",
    fill: "#93b847"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 217.33,
    width: 21.61,
    height: 66.41,
    transform: "translate(-69.15 35.08) rotate(-16.88)",
    fill: "#015e85"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.47,
    y: 206.21,
    width: 21.61,
    height: 66.41,
    transform: "translate(-64.34 45.24) rotate(-16.88)",
    fill: "#015e85"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.13,
    y: 195.08,
    width: 21.61,
    height: 66.41,
    transform: "translate(-59.53 55.41) rotate(-16.88)",
    fill: "#015e85"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 182.78,
    y: 183.96,
    width: 21.61,
    height: 66.41,
    transform: "translate(-54.72 65.57) rotate(-16.88)",
    fill: "#015e85"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 219.43,
    y: 172.84,
    width: 21.61,
    height: 66.41,
    transform: "translate(-49.91 75.73) rotate(-16.88)",
    fill: "#015e85"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 256.09,
    y: 161.72,
    width: 21.61,
    height: 66.41,
    transform: "translate(-45.1 85.9) rotate(-16.88)",
    fill: "#015e85"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 391.48,
    y: 120.63,
    width: 21.61,
    height: 66.41,
    transform: "translate(-27.34 123.44) rotate(-16.88)",
    fill: "#ff9a00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 405.32,
    y: 124.3,
    width: 28.81,
    height: 48.31,
    transform: "translate(-25.02 128.28) rotate(-16.88)",
    fill: "#ff9a00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 477.7,
    y: 228.64,
    width: 80.35,
    height: 58.09,
    transform: "translate(-52.51 161.48) rotate(-16.88)",
    fill: "#ff9a00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 326.95,
    y: 419.46,
    width: 80.35,
    height: 82.15,
    transform: "translate(-117.91 126.45) rotate(-16.88)",
    fill: "#ff9a00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 441.03,
    y: 326.76,
    width: 146.07,
    height: 89.9,
    transform: "translate(-85.79 165.29) rotate(-16.88)",
    fill: "#f4abe0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 260.24,
    y: 264.17,
    width: 98.3,
    height: 89.14,
    transform: "translate(-76.32 103.14) rotate(-16.88)",
    fill: "#015e85"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 199.84,
    y: 413.59,
    width: 58.32,
    height: 52.89,
    transform: "translate(-117.91 85.46) rotate(-16.88)",
    fill: "#015e85"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 428.13,
    y: 109.51,
    width: 21.61,
    height: 66.41,
    transform: "translate(-22.53 133.61) rotate(-16.88)",
    fill: "#ff9a00"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 118.49,
    y: 308.19,
    width: 21.61,
    height: 185.66,
    transform: "translate(-110.88 54.82) rotate(-16.88)",
    fill: "#015e85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 378.11,
    cy: 212.13,
    r: 16.75,
    fill: "#16a99e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 261.2,
    r: 16.75,
    fill: "#16a99e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.34,
    cy: 311.76,
    r: 16.75,
    fill: "#16a99e"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComputerChips, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/computer_chips.322c944b.svg";
export { ForwardRef as ReactComponent };